module.exports = __webpack_public_path__ + "img/4_5.73cd58fa.png";